$(function() {
  //November 17, 2015 - 10am ET
  var nextYear = moment.tz("2023-11-30 23:59", "America/Toronto");

  $('#clockdown').countdown(nextYear.toDate(), function(event) {
    var $this = $(this).html(event.strftime(''
                                            + '<span>%D</span> DAYS '
                                            + '<span>%H</span> HR '
                                            + '<span>%M</span> MIN '
                                            + '<span>%S</span> SEC'));
  });
});
